import { createFileRoute } from '@tanstack/react-router'
import ContactTexts from 'Contact/components/Contact/Sections/ContactTexts'

export const Route = createFileRoute('/contact/$contactId/texts')({
    component: ContactTexts,
})
